/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:16:57
*/


const cacheReducer = (state = {}, action) => {
	if(action.type === 'SET_CACHE') {
		state[action.key] = action.payload;
		console.log("final cacheReducer state >>",state);
		return state;
	}else {
		return state
	}
}

export default cacheReducer;


// const cacheReducer = (state = {"querySubscriberResponse":{},"serviceListResponse":[],"fetchAccountDetailsResponse":{}}, action) => {
// 	if(action.type === 'SET_CACHE') {
// 		// state[action.key] = action.payload;
// 		var newState = {};
// 		Object.assign(newState, state);
// 		insertDataIntoGivenPath(newState,action.key,action.payload);
// 		console.log("final cacheReducer state >>",newState);
// 		return newState;
// 	}else {
// 		return state
// 	}
// }

// function insertDataIntoGivenPath(obj, props, newValue) {
// 	var propsArr = props.split('.');
// 	var prop = propsArr.splice(0, 1);
// 	var nextObject = obj[prop];
// 	if (!propsArr.join('.')) {
// 		return obj[prop] = newValue;
// 	} else {
// 		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
// 		return obj;
// 	}
// }
